import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Layout from './components/Layout/Layout';
import Login from './pages/Auth/Login';
import ForgotPassword from './pages/Auth/ForgotPassword';
import ResetPassword from './pages/Auth/ResetPassword';
import Dashboard from './pages/Dashboard/Dashboard';
import Cases from './pages/Cases/Cases';
import CaseDetail from './pages/Cases/CaseDetail';
import CreateCase from './pages/Cases/CreateCase';
import PendingCasesPerInvestigator from './pages/Cases/PendingCasesPerInvestigator';
import Flags from './pages/Flags/Flags';
import FlagDetail from './pages/Flags/FlagDetail';
import Profiles from './pages/Profiles/Profiles';
import Todos from './pages/Todos/Todos';
import CreateTodo from './pages/Todos/CreateTodo';
import TodoDetail from './pages/Todos/TodoDetail';
import Calendar from './pages/Calendar/Calendar';
import Spotlight from './pages/Spotlight/Spotlight';
import Watchlist from './pages/Watchlist/Watchlist';
import RequestForms from './pages/RequestForms/RequestForms';
import ActivityLog from './pages/ActivityLog/ActivityLog';
import Reports from './pages/Reports/Reports';
import DepositFlagReview from './pages/DepositFlagReview/DepositFlagReview';
import Settings from './pages/Settings/Settings';
import Users from './pages/Users/Users';
import Profile from './pages/Profile/Profile';
import TaskBoard from './pages/Tools/TaskBoard';
import GanttChart from './pages/Tools/GanttChart';
import PrivateRoute from './components/Auth/PrivateRoute';
import { useSessionTimeout } from './hooks/useSessionTimeout';

function App() {
  // Initialize session timeout monitoring
  useSessionTimeout();

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route
        path="/*"
        element={
          <PrivateRoute>
            <Layout>
              <Routes>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/cases" element={<Cases />} />
                <Route path="/cases/create" element={<CreateCase />} />
                <Route path="/cases/pending-per-investigator" element={<PendingCasesPerInvestigator />} />
                <Route path="/cases/:id" element={<CaseDetail />} />
                <Route path="/flags" element={<Flags />} />
                <Route path="/flags/:id" element={<FlagDetail />} />
                <Route path="/profiles" element={<Profiles />} />
                <Route path="/todos" element={<Todos />} />
                <Route path="/todos/create" element={<CreateTodo />} />
                <Route path="/todos/:id" element={<TodoDetail />} />
                <Route path="/cases/:caseId/todos/create" element={<CreateTodo />} />
                <Route path="/calendar" element={<Calendar />} />
                <Route path="/spotlight" element={<Spotlight />} />
                <Route path="/watchlist" element={<Watchlist />} />
                <Route path="/request-forms" element={<RequestForms />} />
                <Route path="/activity-log" element={<ActivityLog />} />
                <Route path="/reports" element={<Reports />} />
                <Route path="/deposit-flag-review" element={<DepositFlagReview />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/users" element={<Users />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/tools/task-board" element={<TaskBoard />} />
                <Route path="/tools/gantt-chart" element={<GanttChart />} />
              </Routes>
            </Layout>
          </PrivateRoute>
        }
      />
    </Routes>
  );
}

export default App;

